import * as React from "react"
import type { EntityTransaction } from "@digits-graphql/frontend/graphql-bearer"
import { DigitsTooltip } from "@digits-shared/DesignSystem/Tooltip"
import { ComponentHeaderTitle } from "src/frontend/components/Shared/Layout/Components/Headers/ComponentSummary"
import { TopTransactionsList } from "src/frontend/components/Shared/Layout/Components/Lists/TopTransactionsList"
import { useComponentConfigTitle } from "src/frontend/components/Shared/Layout/Components/useComponentTitle"
import type { ComponentSize } from "src/frontend/components/Shared/Layout/ComponentSize"
import type { MatchedConfig } from "src/frontend/components/Shared/Layout/types"
import { useTextIsOverflowing } from "src/frontend/hooks/useTextIsOverflowing"

interface ComponentProps {
  config: MatchedConfig<"topTransactions">
  componentSize: ComponentSize
  transactions: EntityTransaction[] | undefined
  loading: boolean
}

/*
  COMPONENTS
*/

export const TopTransactionsComponent: React.FC<ComponentProps> = ({
  config,
  componentSize,
  transactions,
  loading,
}) => {
  const { textElementRef, isTextOverflowing } = useTextIsOverflowing<HTMLDivElement>()
  const { title, periodName } = useComponentConfigTitle({ config })

  return (
    <>
      <DigitsTooltip content={<div> {title}</div>} disabled={!isTextOverflowing}>
        <ComponentHeaderTitle
          ref={textElementRef}
          title={title}
          componentSize={componentSize}
          periodName={periodName}
        />
      </DigitsTooltip>
      <TopTransactionsList transactions={transactions} loading={loading} />
    </>
  )
}
